<div>
  <div class="text-template-wrapper" [ngClass]="{'has-error': !inputState.valid}">
    <app-text-template [hidden]="!templateModel.hasTelqId" (changeText)="onChangeText($event)"
      (markerClick)="telqIdModalOpen(templateModel)"></app-text-template>
    <textarea [hidden]="templateModel.hasTelqId" [value]="templateModel.text" (input)="onInputTextarea($event)" rows="5"
      class="form-control text-input-textarea"></textarea>
    <div *ngIf="inputState.currentLength > 0" class="counter">{{ inputState.currentLength }} / {{ inputState.maxLength }}</div>
    <a class="add-icon" [hidden]="!templateModel.text || !inputState.valid" (click)="addText(templateModel)">
      <span class="icon-add"></span>
    </a>
  </div>
  <ul [hidden]="!texts.length" class="input-list-items">
    <li *ngFor="let template of texts" class="d-inline-flex justify-content-start align-items-center">
      <span class="pre d-inline-flex justify-content-start align-items-center" (click)="onClickText($event, template)" [attr.title]="template.text"
        [innerHTML]="getTrimmedText(template.text)"></span>
      <button (click)="removeText(template)" class="input-list-remove btn btn-sm mt-0" type="button">
        <i class="text-danger fa fa-times" title="Remove"></i>
      </button>
    </li>
  </ul>
  <div class="d-flex justify-content-between align-items-center">
    <div class="form-group mt-10">
      <div class="input-check d-flex align-items-center gap-10 cp" (click)="onClickHasTelqId()">
        <input type="checkbox" class="form-check-input" [checked]="templateModel.hasTelqId" />
        <span class="text" for="domestic">Include ID</span>
      </div>
    </div>
    <div *ngIf="templateModel.hasTelqId && inputState.currentLength > 0">
      <a href="https://help.telqtele.com/tp/Test-ID-Text.2803826689.html" target="_blank" class="btn btn-sm btn-link">What is ID?</a>
    </div>
  </div>
</div>


<ng-template #telqIdModalTpl let-dialogRef="dialogRef">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test ID Text Settings</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="telqIdSettingsForm" class="d-flex flex-column gap-15 mb-15">
      <div class="form-group">
        <label class="form-label required">Type </label>
        <select [(ngModel)]="telqIdSettings.telqIdType" (change)="onChangeTelqIdSettingsType()" formControlName="telqIdType" class="form-control">
          <option *ngFor="let type of telqIdSettingsTypes" [value]="type.id">{{type.label}}</option>
        </select>
        <input-errors [control]="telqIdSettingsForm.controls.telqIdType" [service]="validationService"></input-errors>
      </div>
      <div [hidden]="!telqIdSettingsShowCase(telqIdSettings.telqIdType)" class="form-group">
        <label class="form-label required">Case </label>
        <select [(ngModel)]="telqIdSettings.telqIdCase" formControlName="telqIdCase" class="form-control">
          <option *ngFor="let case of telqIdSettingsCases" [value]="case.id">{{case.label}}</option>
        </select>
        <input-errors [control]="telqIdSettingsForm.controls.telqIdCase" [service]="validationService"></input-errors>
      </div>
      <div [hidden]="!telqIdSettingsShowLength(telqIdSettings.telqIdType)" class="form-group">
        <label class="form-label required">Length </label>
        <input [(ngModel)]="telqIdSettings.telqIdLength" formControlName="telqIdLength" type="number" class="form-control">
        <input-errors [control]="telqIdSettingsForm.controls.telqIdLength" [service]="validationService"></input-errors>
      </div>
    </form>
  </div>
  <div class="modal-footer pt-10">
    <button [disabled]="!telqIdSettingsForm.valid" class="btn btn-primary" type="button" (click)="telqIdModalApply(true)">Save as default</button>
    <button [disabled]="!telqIdSettingsForm.valid" class="btn btn-primary" type="button" (click)="telqIdModalApply(false)">Apply</button>
  </div>
</ng-template>
